import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'

export default function AnimatedQuote({ text, className }) {
    const [displayedText, setDisplayedText] = useState('')
    const [cursorVisible, setCursorVisible] = useState(true)

    useEffect(() => {
        if (typeof window !== 'undefined' && window.__PRERENDER__) return

        let currentIndex = 0
        const typingSpeed = 60

        const typingInterval = setInterval(() => {
            const nextChar = text.charAt(currentIndex)
            if (nextChar) {
                setDisplayedText((prev) => prev + nextChar)
                currentIndex++
            } else {
                clearInterval(typingInterval)
            }
        }, typingSpeed)

        return () => clearInterval(typingInterval)
    }, [text])

    useEffect(() => {
        if (typeof window !== 'undefined' && window.__PRERENDER__) return

        const cursorInterval = setInterval(() => {
            setCursorVisible((prev) => !prev)
        }, 500)

        return () => clearInterval(cursorInterval)
    }, [])

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className={'animated-quote ' + (className || '')}
        >
            <span className="animated-quote-sr">{text}</span>
            <span aria-hidden="true">
                {displayedText}
                <span className={`cursor ${cursorVisible ? 'visible' : ''}`}>|</span>
            </span>
        </motion.div>
    )
}
